export default __webpack_public_path__ + "static/media/1a5821e0d3dd722c.327fe1909d423aae4cb4b1b16ee0be07.svg";